import { useEffect } from 'react';

import { paramsExtract } from './paramsExtract';
import { UTMDto } from '@skillarea/lib-shared';
import { useNavigate } from '@tanstack/react-router';

const UTMParams = new Set(
  Object.keys({
    utm_campaign: '',
    utm_content: '',
    utm_medium: '',
    utm_source: '',
    utm_term: '',
  } as UTMDto),
);

export const UTMTagSaver = ({
  cookiesStore,
  isLoggedIn,
}: {
  cookiesStore: any;
  isLoggedIn: boolean;
}) => {
  const navigate = useNavigate();
  useEffect(() => {
    const UTMData = paramsExtract(UTMParams, navigate);
    if (!isLoggedIn && Object.keys(UTMData).length)
      cookiesStore.saveUTM({ body: UTMData });
  }, [cookiesStore, isLoggedIn, navigate]);
  return null;
};
